export const TIME_ZONE = 'America/Dawson_Creek';

const sessionFormatter = new Intl.DateTimeFormat('en-CA', {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  timeZone: TIME_ZONE,
});

const dayFormatter = new Intl.DateTimeFormat('en-CA', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  timeZone: TIME_ZONE,
});

const shortFormatter = new Intl.DateTimeFormat('en-CA', {
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  timeZone: TIME_ZONE,
});

export function sessionAt(at: string | number): string {
  return sessionFormatter.format(new Date(at));
}

export function sessionRange(startsAt: string, endsAt: string | null): string {
  const start = new Date(startsAt);
  if (!endsAt) return sessionFormatter.format(start);
  return sessionFormatter.formatRange(start, new Date(endsAt));
}

export function dayAt(iso: string): string {
  return dayFormatter.format(new Date(iso));
}

export function shortAt(iso: string): string {
  return shortFormatter.format(new Date(iso));
}

const keyFormatter = new Intl.DateTimeFormat('en-CA', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  timeZone: TIME_ZONE,
});

/** The local calendar day holding `at`, as YYYY-MM-DD. */
export function dayKey(at: string | number): string {
  return keyFormatter.format(new Date(at));
}

/** The Sunday that starts the league week holding a YYYY-MM-DD day. */
export function weekStartOf(date: string): string {
  const [year, month, day] = date.split('-').map(Number);
  const midnight = Date.UTC(year!, month! - 1, day!);
  const weekday = new Date(midnight).getUTCDay();
  return new Date(midnight - weekday * 86_400_000).toISOString().slice(0, 10);
}

export function dollars(cents: number, currency = 'CAD'): string {
  return new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency,
  }).format(cents / 100);
}
